import { useState, useEffect, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppRoutes } from "./routes";
import "../node_modules/primeflex/primeflex.css";
import "./App.css"
import { PrimeReactProvider } from "primereact/api";

function App(props) {
  const [menuAllow, setMenuAllow] = useState([]);

  useEffect(() => {
    const menu = AppRoutes(props);
    setMenuAllow(menu);
  }, []);

  return (
    <Router>
      <PrimeReactProvider value={{ inputStyle: 'filled', size: 'small' }}>
      <Suspense fallback={<div>Loading...</div>}>
      <div className="flex w-full h-full flex align-items-center justify-content-center overflow-x-hidden" >
        <Routes>
          {menuAllow.map((r, index) => (
            <Route
              key={index}
              path={r.path}
              element={<r.component {...r.props} />}
            />
          ))}
        </Routes>
      </div>
      </Suspense>
      </PrimeReactProvider>
    </Router>
  );
}

export default App;
